import { gql } from '@apollo/client'

export const myCreditCards = gql`
  query MyCreditCards($fundId: Int!) {
    me {
      id
      fund(id: $fundId) {
        id
        creditCards {
          id
          details
          multiUse
          status
          default
          canDelete
        }
      }
    }
  }
`
export const myLinkedBanks = gql`
  query MyLinkedBanks($fundId: Int!) {
    me {
      id
      fund(id: $fundId) {
        id
        linkedBanks {
          id
          details
          canDelete
        }
      }
    }
  }
`

export const getZumrailsToken = gql`
  query getZumrailsToken($fundId: Int, $charityId: String) {
    getZumrailsToken(fundId: $fundId, charityId: $charityId)
  }
`

export const getZumrailsTokenGuest = gql`
  query getZumrailsTokenGuest($id: Int!) {
    getZumrailsTokenGuest(id: $id)
  }
`

export const userHasBankAccount = gql`
  query userHasBankAccount($fundId: Int, $charityId: String) {
    userHasBankAccount(fundId: $fundId, charityId: $charityId)
  }
`

export const guestHasBankAccount = gql`
  query guestHasBankAccount($email: String!) {
    guestHasBankAccount(email: $email)
  }
`

export const getZumRailsUser = gql`
  query getZumRailsUser {
    getZumRailsUser
  }
`

export const getZumRailsUserGuest = gql`
  query getZumRailsUserGuest($id: Int!) {
    getZumRailsUserGuest(id: $id)
  }
`

export const linkedZumRailsBanks = gql`
  query linkedZumRailsBanks($fundId: Int) {
    linkedZumRailsBanks(fundId: $fundId) {
      Id
      Institution
      InstitutionNumber
      TransitNumber
      AccountNumber
      AccountType
      Name
      FirstName
      LastName
      CreatedAt
      AggregationStatus
      LastTimeRefreshed
      AggregationFailedReason
      AggregationBalance
      HasMinimumInformationForEft
      FundingSourceStatus
      Country
      NameMatchResult
      NameMatchScore
      UpdatedAt
      AggregationRequestId
      PaymentMethodId
      zumUserId
      canDelete
    }
  }
`

export const publicLinkedZumRailsBanks = gql`
  query publicLinkedZumRailsBanks($id: Int!) {
    publicLinkedZumRailsBanks(id: $id) {
      Institution
      AccountNumberLast4
      PaymentMethodId
    }
  }
`
